import React, { useState, useEffect } from "react";
import { Routes, Route, Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import "./QrDashbordNavbar.css"
import axios from "axios";


import Rider from "./Rider/Rider";
import ChangePassword from "./ChangePassword/ChangePassword";


const QrDashbordNavbar = () => {

  const location = useLocation();
  // const riderId = location.state?.deliveryBoyId;
  const riderId = localStorage.getItem("deliveryBoyId");
  const navigate = useNavigate()

  const [selectedLabel, setSelectedLabel] = useState("Rider");

  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const RiderTransactionButton = [
    { label: "Rider", path: "Rider" },
    { label: "Change Password", path: "ChangePassword" },
  ];


  const API_BASE_URL = process.env.REACT_APP_SERVER_API;
  useEffect(() => {
    // Extract the last segment of the path after the final slash
    const currentPathSegment = location.pathname.split("/").pop();

    const currentButton = RiderTransactionButton.find(
      (button) => button.path === currentPathSegment
    );

    if (currentButton) {
      setSelectedLabel(currentButton.label);
    }
  }, [location.pathname, RiderTransactionButton]);

  const handleButtonClick = (label) => {
    // setSelectedLabel(label);
    setSidebarVisible(false);
  };
  const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);



  const handleLogOut = async () => {
    try {
      const response = await axios.put(`${API_BASE_URL}/DeliveryBoy/RiderLogout?delboyId=${riderId}`)
      console.log("Logout successful:", response.data);

      // Clear localStorage (if needed)
      localStorage.removeItem("deliveryBoyId");
      navigate("/")
      // Close the tab (only works if it's user-initiated)


    } catch (error) {
      console.log("Logout API Error", error);
    }
  }


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 d-flex align-items-center">
            {/* Master Creation title */}
            <h2 className="MasterCreationtext">
              <i>Rider</i>
            </h2>

            {/* Selected label */}
            <h6 className="selectedalble"><i>{localStorage.getItem("delboyName")}</i></h6>
            {isSidebarVisible ? (
              <IoClose
                className="ms-auto me-2 d-inline closeicon sidebar-toggle-icon"
                onClick={toggleSidebar}
              />
            ) : (
              <IoMenu
                className="ms-auto me-2 d-inline menuicon sidebar-toggle-icon"
                onClick={toggleSidebar}
              />
            )}
            <button className="btn btn-primary"
              onClick={handleLogOut}
            >
              Logout
            </button>
          </div>

          <hr className="MasterCreationtextBttomline" />
        </div>
      </div>

      <div className="container-fluid">
        <div className=" row mt-3">
          {/* Left column for buttons with scroll functionality */}
          <div className={`sidebar ${isSidebarVisible ? "open" : ""}`}>
            <div className="button-container">
              {RiderTransactionButton.map((button, index) => (
                <Link
                  key={index}
                  to={button.path}
                  className="btn btn-primary MasterCreationButtons mb-2"
                  onClick={() => handleButtonClick(button.label)}
                >
                  {button.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Right column for content */}
          <div className="col-md-10 maincontentshow p-0">
            <Routes>
              {/* Redirect to MasterType when accessing /MasterCreation */}
              <Route path="/" element={<Navigate to="Rider" replace />} />

              <Route
                path="Rider"
                element={<Rider label={selectedLabel} />}
              />
              <Route
                path="ChangePassword"
                element={<ChangePassword label={selectedLabel} />}
              />
              {/* <Route
                path="DeliveryBoy"
                element={<DeliveryBoy label={selectedLabel} />}
              /> */}



            </Routes>
          </div>
        </div>
      </div>
    </>
  )
}

export default QrDashbordNavbar
